<template>
  <article>
    <group gutter="0px" class="car_in_city" v-if="carStoreList.length">
      <x-input title="同城车商" class="car_city">
        <checklist slot="right" :options="allList" v-model="selectAll" @on-change="change" class="all_in"></checklist>
      </x-input>
      <checklist :options="canSel" v-model="carStore" label-position="left"></checklist>
      <checklist :options="cantSel" disabled label-position="left"></checklist>
    </group>
    <section class="btn-bottom" v-if="carStoreList.length">
      <div class="btn-fix">
        <a class="btn" @click.stop="sure()">确定</a>
      </div>
    </section>
    <section class="data-messages-null" v-else>
      <img src="../../stylesheets/images/icon/no-vehicwle-icon.jpg" class="no-vehicle" width="88" height="88" />
      <br>
      <br> 暂无车商
      <p class="tips">请邀请车商进驻后再询价</p>
    </section>
  </article>
</template>
<script>
import {
  Group,
  Checklist,
  XInput
} from '@lx-frontend/cvux'
import cache from '../../common/cache'

export default {
  components: {
    Group,
    Checklist,
    XInput
  },
  data() {
    return {
      carStoreList: [],
      selectAll: [],
      allList: ['全选'],
      carStore: [],
      canSel: [],
      cantSel: [],
      submitKey: 'queryForm',
      queryForm: {}
    }
  },
  created() {
    // 获取同城车商列表，并判断可选和不可选
    this.queryForm = cache.getSessionData(this.submitKey)
    this.$rest.inquiry.getDealerUsers().then((res) => {
      if (res.code === 0) {
        this.carStoreList = res.data.car_dealers
        let canInAll = this.carStoreList.filter(v => {
          return v.is_qualified
        })
        let cantInAll = this.carStoreList.filter(v => {
          return !v.is_qualified
        })
        this.canSel = canInAll.map(v => {
          return {
            key: v.dealer_user_id + '',
            value: v.dealer_user_name
          }
        })
        this.cantSel = cantInAll.map(v => {
          return {
            key: v.dealer_user_id + '',
            value: v.dealer_user_name
          }
        })
      } else {
        this.isClicked = false
        this.showToast(res.message)
      }
    })
  },
  methods: {
    change(val) {
      if (val.length) {
        let all = []
        this.canSel.forEach(v => {
          all.push(v.key)
        })
        this.carStore = all
      } else {
        this.carStore = []
      }
    },
    sure() {
      if (this.canSel.length) {
        let nameList = ''
        this.carStore.forEach(v => {
          let item = this.canSel.find(item => {
            return item.key === v
          })
          nameList += item.value + '；'
        })
        this.queryForm.dealer_user_name = nameList
        this.queryForm.invited_dealer_users = this.carStore.join(',')
        cache.setSessionData(this.submitKey, this.queryForm)
        this.$router.go(-1)
      } else {
        this.showToast('请选择车商')
      }
    }
  }
}

</script>
<style lang="less">
@w2: 75rem;
.car_in_city .weui_cells:after{
  border: none;
}
.car_city {
  .all_in .weui_cells_checkbox {
    .weui_cell {
      padding: 0;
    }
  }
  .all_in .weui_cells_checkbox:before {
    border: none;
  }
  .all_in .weui_cells_checkbox:after {
    border: none;
  }
}
</style>
